module.exports = __webpack_public_path__ + "media/27.b75bbbd1.mp3";